/**
 * Icônes au trait (Lucide) des pages charte « apple » (Karim 2026-10-18) :
 * remplace les illustrations « mains » (`/svg/hands-*.svg`) des anciennes
 * pages par leur équivalent sobre. Une icône inconnue → flèche neutre.
 */
const EQUIVALENTS: Record<string, string> = {
  check: "i-lucide-check-circle-2",
  coin: "i-lucide-coins",
  baby: "i-lucide-baby",
  heart: "i-lucide-heart",
  "heart-2": "i-lucide-heart-handshake",
  handshak: "i-lucide-handshake",
  target: "i-lucide-target",
  "tap-to-pay": "i-lucide-smartphone-nfc",
  pencil: "i-lucide-pencil-line",
  globe: "i-lucide-globe",
  chart: "i-lucide-bar-chart-3",
  "qr-code": "i-lucide-qr-code",
  clac: "i-lucide-scale",
  ticket: "i-lucide-ticket",
  no: "i-lucide-circle-slash",
  trophy: "i-lucide-trophy",
  rocket: "i-lucide-rocket",
  mail: "i-lucide-mail",
  leaf: "i-lucide-leaf",
  sparkles: "i-lucide-sparkles",
  palette: "i-lucide-palette",
  money: "i-lucide-banknote",
  megaphone: "i-lucide-megaphone",
  link: "i-lucide-link",
  calendar: "i-lucide-calendar",
  search: "i-lucide-search",
  message: "i-lucide-message-circle",
  music: "i-lucide-music",
  map: "i-lucide-map-pin",
  gauge: "i-lucide-gauge",
  cup: "i-lucide-coffee",
  settings: "i-lucide-settings",
};

/** « /svg/hands-coin.svg » → « i-lucide-coins » ; une icône Lucide passe telle quelle. */
export function iconeApple(icone: string): string {
  if (icone.startsWith("i-")) return icone;
  const nom = icone.replace(/^.*\/hands-/, "").replace(/\.svg$/, "");
  return EQUIVALENTS[nom] ?? "i-lucide-arrow-up-right";
}
